export default __webpack_public_path__ + "static/media/edit_delete.793c59f4.svg";